import type MailboxInfo from "./MailboxInfo";

/**
 * MailboxInfo for anonymous user flows where no M365 account is available,
 * such as FindTime/Scheduling Poll voting pages, Bookings public booking
 * links, and Meet room check-in for non-M365 users.
 *
 * For telemetry call sites, obtain via getAnonymousMailboxInfoForTelemetry()
 * from owa-mailbox-info. Usage is flagged by the
 * owa-custom-rules/no-restricted-function ESLint rule and requires an explicit
 * eslint-disable comment with justification.
 */
export interface AnonymousMailboxInfo extends MailboxInfo {
    readonly isAnonymous: true;
}

export function isAnonymousMailboxInfo(mailboxInfo: MailboxInfo): mailboxInfo is AnonymousMailboxInfo {
    return mailboxInfo.isAnonymous === true;
}
